import {
  MANUAL_PO_ENQUIRY_ERROR,
  MANUAL_PO_ENQUIRY_REQUEST,
  RESET_MANUAL_PO_ENQUIRY,
  MANUAL_PO_ENQUIRY_SUCCESS,
} from "redux/actions/action-type";

const initialState = {
  orders: [],
  errorDetails: {},
  metadata: {},
  isPOEnquiryLoading: false,
  isPOEnquiryError: false,
  isPOEnquirySuccess: false,
};

const purchaseOrderEnquiryReducer = (state = initialState, action) => {
  switch (action.type) {
    case MANUAL_PO_ENQUIRY_REQUEST:
      return {
        ...state,
        isPOEnquiryLoading: true,
        isPOEnquiryError: false,
        isPOEnquirySuccess: false,
      };

    case MANUAL_PO_ENQUIRY_SUCCESS:
      const { orders, metadata } = action.payload;
      return {
        ...initialState,
        isPOEnquiryLoading: false,
        orders: orders,
        metadata: metadata,
        isPOEnquiryError: false,
        isPOEnquirySuccess: true,
        errorDetails: {},
      };

    case MANUAL_PO_ENQUIRY_ERROR:
      return {
        ...state,
        isPOEnquiryLoading: false,
        orders: [],
        isPOEnquiryError: true,
        isPOEnquirySuccess: false,
        errorDetails: action.payload,
      };

    case RESET_MANUAL_PO_ENQUIRY:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default purchaseOrderEnquiryReducer;
